export default {
  overlay: {
    component: '',
    data: null,
  },
  error: { resource: null, code: null },
}
